<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm">
      <div class="modal-content">
        <div class="main">
          <div (click)="closeModal()" class="close-icon">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
          <div class="text-center">
            <img id="success-icon" src="assets/image/success-icon.svg" />
          </div>
          <div class="mt-3 text-center">
            <h3>Cadastro completado com sucesso!</h3>
            <p class="p-text-grey mt-3 mb-5">
              Iremos analisar as informações e documentos enviados, mas você já pode iniciar o processo de envio e recebimento do exterior.
            </p>
          </div>
          <div class="row d-flex justify-content-center button-close" >
            <button class="btn btn-block mt-3" type="button" (click)="closeModal()">
              Fechar
            </button>
          </div>
        </div>
      </div> 
    </div>
  </div>
</div>